import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IRootState } from '../../../state-mgmt/rootState';
import DenyUser from './DenyUser';
import { userState } from '../../../state-mgmt/user';
import { GENERAL } from '../../../../constants';
import { generalState } from '../../../state-mgmt/general';
import { push } from 'connected-react-router';

export const mapStateToProps = (state: IRootState) => ({
  denyUserResult: state.user.denyUserResult,
  denyUserLoading: state.general.loadingMap[GENERAL.LOADING_KEY.DENY_USER],
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  denyUser: (userId: string, companyId: string, projectId: string) => dispatch(userState.actions.denyUserStart(userId, companyId, projectId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DenyUser);
